exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".psychological-month-report[data-v-5bbcbc5a] {\n  margin: -12px -12px 0px;\n  background-color: #f0f2f5;\n  font-size: 14px;\n}\n.psychological-month-report .main-body[data-v-5bbcbc5a] {\n  padding: 20px;\n}\n.psychological-month-report[data-v-5bbcbc5a] .ant-back-top {\n  right: 50px !important;\n  z-index: 99;\n}\n", ""]);

// exports
